/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GenerateSettlementReportByTenantOptions,
  GenerateSettlementReportByTenantStatus200,
  GenerateSettlementReportByTenantStatus400,
  GenerateSettlementReportByTenantStatus401,
  GenerateSettlementReportByTenantStatus404,
  GenerateSettlementReportByTenantStatus409,
  GenerateSettlementReportByTenantStatus500,
  GenerateSettlementReportByTenantStatus503,
} from '../types/GenerateSettlementReportByTenant'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { generateSettlementReportByTenant } from '../clients/generateSettlementReportByTenant'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const generateSettlementReportByTenantMutationKey = () =>
  [{ url: '/v1/tenants/:tenant_id/settlements/generate' }] as const

export function generateSettlementReportByTenantMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = generateSettlementReportByTenantMutationKey()
  return mutationOptions<
    GenerateSettlementReportByTenantStatus200,
    ResponseErrorConfig<
      | GenerateSettlementReportByTenantStatus400
      | GenerateSettlementReportByTenantStatus401
      | GenerateSettlementReportByTenantStatus404
      | GenerateSettlementReportByTenantStatus409
      | GenerateSettlementReportByTenantStatus500
      | GenerateSettlementReportByTenantStatus503
    >,
    GenerateSettlementReportByTenantOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return generateSettlementReportByTenant({
        ...config,
        path,
        body,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Generate and send settlement report for a tenant by date range.
 * {@link /v1/tenants/:tenant_id/settlements/generate}
 */
export function useGenerateSettlementReportByTenant<TContext>(
  options: {
    mutation?: UseMutationOptions<
      GenerateSettlementReportByTenantStatus200,
      ResponseErrorConfig<
        | GenerateSettlementReportByTenantStatus400
        | GenerateSettlementReportByTenantStatus401
        | GenerateSettlementReportByTenantStatus404
        | GenerateSettlementReportByTenantStatus409
        | GenerateSettlementReportByTenantStatus500
        | GenerateSettlementReportByTenantStatus503
      >,
      GenerateSettlementReportByTenantOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? generateSettlementReportByTenantMutationKey()

  const baseOptions = generateSettlementReportByTenantMutationOptions(config) as UseMutationOptions<
    GenerateSettlementReportByTenantStatus200,
    ResponseErrorConfig<
      | GenerateSettlementReportByTenantStatus400
      | GenerateSettlementReportByTenantStatus401
      | GenerateSettlementReportByTenantStatus404
      | GenerateSettlementReportByTenantStatus409
      | GenerateSettlementReportByTenantStatus500
      | GenerateSettlementReportByTenantStatus503
    >,
    GenerateSettlementReportByTenantOptions,
    TContext
  >

  return useMutation<
    GenerateSettlementReportByTenantStatus200,
    ResponseErrorConfig<
      | GenerateSettlementReportByTenantStatus400
      | GenerateSettlementReportByTenantStatus401
      | GenerateSettlementReportByTenantStatus404
      | GenerateSettlementReportByTenantStatus409
      | GenerateSettlementReportByTenantStatus500
      | GenerateSettlementReportByTenantStatus503
    >,
    GenerateSettlementReportByTenantOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    GenerateSettlementReportByTenantStatus200,
    ResponseErrorConfig<
      | GenerateSettlementReportByTenantStatus400
      | GenerateSettlementReportByTenantStatus401
      | GenerateSettlementReportByTenantStatus404
      | GenerateSettlementReportByTenantStatus409
      | GenerateSettlementReportByTenantStatus500
      | GenerateSettlementReportByTenantStatus503
    >,
    GenerateSettlementReportByTenantOptions,
    TContext
  >
}
